/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} SlotsInputs */

const en_slots = /** @type {(inputs: SlotsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slots`)
};

const de_slots = /** @type {(inputs: SlotsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plätze`)
};

/**
* | output |
* | --- |
* | "Slots" |
*
* @param {SlotsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const slots = /** @type {((inputs?: SlotsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<SlotsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_slots(inputs)
	return en_slots(inputs)
});